function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.18 2 2.01 4.17 2.01 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 9.24h2c.55 0 1-.45 1-1V8c0-1.66-1.34-3-3-3H8C6.34 5 5 6.34 5 8v.5c0 .55.45 1 1 1h1.34c1.31 0 2.5.94 2.63 2.25a2.5 2.5 0 01-2.49 2.76H6c-.55 0-1 .45-1 1v.5c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3v-.25c0-.55-.45-1-1-1h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.55 0 1-.45 1-1v-.51c0-.55-.45-1-1-1h-2c-.41 0-.75-.33-.75-.75s.34-.76.75-.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 13H6c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1z"
})));